import { BaccaratCardType } from '@bg-shared/enums/BaccaratCardType';
import { IBaccaratGameState, IBaccaratSelectData } from './interfaces';

export const baccaratSelectors = {
    selectData: (state: IBaccaratGameState): IBaccaratSelectData => ({
        ...state.data,
        oddsGroups: state.oddGroups,
        mainBettingOptions: state.oddGroups[0].ids.map((id) => state.data.bettingOptions[id]),
        panelBettingOptions: state.oddGroups[1].ids.map((id) => state.data.bettingOptions[id]),
        playerCards: state.data.cards.filter((card) => card.dealedTo === BaccaratCardType.PLAYER),
        bankerCards: state.data.cards.filter((card) => card.dealedTo === BaccaratCardType.BANKER),
    }),
};
